module.exports = __webpack_public_path__ + "static/media/4.3f338e7c.JPG";